import { createFileRoute } from "@tanstack/react-router";
import { ProofPage } from "@/features/proofs/ProofPage";

export const Route = createFileRoute("/_app/proofs/$proof")({ component: Page });

function Page() {
  const { proof } = Route.useParams();
  return <ProofPage id={proof} />;
}
